import type { FormFields } from '@/entities/purchase-form';
import { getValues as getPurchaseFormValues, setValue as setPurchaseFormValue } from '@/entities/purchase-form';

export type AppliedCalculatedFrequency = {
    sku: string;
    autoshipFrequency: FormFields['autoshipFrequency'];
    autoshipUnit: FormFields['autoshipUnit'];
    originalAutoshipFrequency: FormFields['autoshipFrequency'];
    originalAutoshipUnit: FormFields['autoshipUnit'];
};

let appliedCalculatedFrequency: AppliedCalculatedFrequency | null = null;

export const getAppliedCalculatedFrequency = (): AppliedCalculatedFrequency | null => appliedCalculatedFrequency;

export const saveAppliedCalculatedFrequency = (applied: AppliedCalculatedFrequency): void => {
    if (appliedCalculatedFrequency?.sku === applied.sku) {
        appliedCalculatedFrequency = {
            ...applied,
            originalAutoshipFrequency: appliedCalculatedFrequency.originalAutoshipFrequency,
            originalAutoshipUnit: appliedCalculatedFrequency.originalAutoshipUnit,
        };
        return;
    }

    appliedCalculatedFrequency = applied;
};

export const clearAppliedCalculatedFrequency = (): void => {
    appliedCalculatedFrequency = null;
};

export const revertAppliedCalculatedFrequency = (): void => {
    if (!appliedCalculatedFrequency) return;

    const stillHasCalculatedValue =
        getPurchaseFormValues('autoshipFrequency') === appliedCalculatedFrequency.autoshipFrequency &&
        getPurchaseFormValues('autoshipUnit') === appliedCalculatedFrequency.autoshipUnit;

    if (stillHasCalculatedValue) {
        setPurchaseFormValue('autoshipFrequency', appliedCalculatedFrequency.originalAutoshipFrequency);
        setPurchaseFormValue('autoshipUnit', appliedCalculatedFrequency.originalAutoshipUnit);
    }

    clearAppliedCalculatedFrequency();
};
